import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { UiButton, UiIcon } from 'ui-components';
import {
  EXPIRE_AT_RANGE_OPTIONS,
  getExpireAtRangeBounds,
} from '../../constants/userListFilters';
import {
  StyledExpireAtRangeFilter,
  StyledExpireAtRangePopover,
} from './ExpireAtRangeFilter.styles';

function ExpireAtRangeFilter({ value = '', onChange }) {
  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const bounds = getExpireAtRangeBounds(value);

  const formatFooterDate = (date) =>
    `${date.format('jD jMMMM')} ${t('common:time')}${date.format('HH:mm')}`;

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOptionClick = (option) => {
    onChange(value === option ? '' : option);
    setAnchorEl(null);
  };

  return (
    <StyledExpireAtRangeFilter>
      <div className='range-picker-trigger' onClick={handleOpen}>
        <span className={`trigger-label${bounds ? '' : ' placeholder'}`}>
          {bounds ? (
            <bdi>
              <span>{t('common:from')}: </span>
              <span className='date'>
                {bounds.from.format('jYYYY/jMM/jDD')}
              </span>
              <span className='time'>{bounds.from.format('HH:mm')}</span>
              <span>{t('common:to')}: </span>
              <span className='date'>{bounds.to.format('jYYYY/jMM/jDD')}</span>
              <span className='time'>{bounds.to.format('HH:mm')}</span>
            </bdi>
          ) : (
            t('users:expireAtRange.filterPlaceholder')
          )}
        </span>
        <UiIcon icon='ri-calendar-2-line' size={20} />
      </div>

      <StyledExpireAtRangePopover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <div className='expire-at-range-content'>
          <div className='expire-at-range-options'>
            {EXPIRE_AT_RANGE_OPTIONS.map((option) => {
              const selected = value === option;
              return (
                <UiButton
                  key={option}
                  className='expire-at-range-option'
                  variant='outlined'
                  color={selected ? 'primary' : 'default'}
                  onClick={() => handleOptionClick(option)}
                >
                  {t(`users:expireAtRange.${option}`)}
                </UiButton>
              );
            })}
          </div>

          {bounds && (
            <div className='expire-at-range-footer'>
              <span>{formatFooterDate(bounds.from)}</span>
              <span>{t('common:to')}</span>
              <span>{formatFooterDate(bounds.to)}</span>
            </div>
          )}
        </div>
      </StyledExpireAtRangePopover>
    </StyledExpireAtRangeFilter>
  );
}

ExpireAtRangeFilter.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default ExpireAtRangeFilter;
